'use strict';

angular.module('searchModule')

.controller('SearchActionsController', ['$scope', '$sce', function ($scope, $sce) {

    $scope.getSearchActions = function () {
        var ctxSearchActions = [];

        if (!_.isEmpty($scope.searchCtx.q)) {
            ctxSearchActions = _.filter($scope.searchConfiguration.ItemSearchActions, function (action) {
                if (_.isUndefined(action.ParentFilteredSearch)) return false;

                var filteredSearchRegex = new RegExp('^' + action.ParentFilteredSearch + '\\b', 'i');

                return filteredSearchRegex.test($scope.searchCtx.q);
            });
        }

        // TODO: Is this needed?
        if (ctxSearchActions.length === 0) {
            ctxSearchActions = _.filter($scope.searchConfiguration.ItemSearchActions, function (action) {
                return _.isUndefined(action.ParentFilteredSearch);
            });
        }

        return ctxSearchActions;
    }

    /*
     * TODO
     * this method is called directly by the ng-repeat many many times, the repeater should only call
     * the result of the function, not the function itself
     */
    $scope.getSearchTypeLinks = function () {

        var typeLinks = _.filter($scope.searchConfiguration.ItemSearchActions, function (action) {
             return _.isUndefined(action.ParentFilteredSearch);
        });

        return typeLinks;
    }

    $scope.executeAction = function (action) {

        var typeRegex = /^(type=[aA-zZ]+) ?(.*)/;
                        // $1             $2

        if (typeRegex.test($scope.searchCtx.q)) {
            $scope.searchCtx.q = $scope.searchCtx.q.replace(typeRegex, action.FilteredSearch + ' $2');
        } else {
            $scope.searchCtx.q = action.FilteredSearch + ' ' + ($scope.searchCtx.q || '');
        }

        $scope.search($scope.searchCtx.q);
    };

    $scope.isSearchTypeActive = function (action) {
        if (!$scope.searchCtx.q) return false;

        return $scope.searchCtx.q.indexOf(action.FilteredSearch) === 0;
    };

    $scope.displayActionHtml = function (action) {
        return $sce.trustAsHtml(action.ActionHtml);
    }
}]);